import { createStyles, Drawer } from '@mantine/core';
import { observer } from 'mobx-react-lite';
import policyIssueStore from '../store';
import { PolicyIssueDrawerContent } from './PolicyIssueDrawerContent';

const useStyles = createStyles({
	drawerBody: {
		width: '100%',
		height: '100%',
		overflowY: 'auto',
		display: 'flex',
		padding: 0,
	},
});

interface PolicyIssueDrawerProps {
	handleAcknowledgeOnClick: (resultId: string) => void;
	handleResolveOnClick: (resultId: string) => void;
	handleIgnoreOnClick: (resultId: string) => void;
	handleReopenOnClick: (resultId: string) => void;
	readOnly?: boolean;
}

export const PolicyIssueDrawer = observer(
	({
		handleAcknowledgeOnClick,
		handleResolveOnClick,
		handleIgnoreOnClick,
		handleReopenOnClick,
		readOnly = false,
	}: PolicyIssueDrawerProps) => {
		const { classes } = useStyles();

		return (
			<Drawer
				classNames={{
					body: classes.drawerBody,
				}}
				position="right"
				opened={policyIssueStore.isOpen}
				onClose={policyIssueStore.closeEntityDrawer}
				size="640"
				withinPortal
				withCloseButton={false}
			>
				<PolicyIssueDrawerContent
					handleAcknowledgeOnClick={handleAcknowledgeOnClick}
					handleResolveOnClick={handleResolveOnClick}
					handleIgnoreOnClick={handleIgnoreOnClick}
					handleReopenOnClick={handleReopenOnClick}
					readOnly={readOnly}
				/>
			</Drawer>
		);
	}
);
